export default __webpack_public_path__ + "static/media/latest-news-img21.67745fdb.jpg";